import { useState, useContext } from "react";
import ordersService from "services/orders.service";
import {AuthContext} from "context";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import MDButton from 'components/MDButton';

import SelectOrganization from "cruds/fulfillment-center/components/select-organization";
import { validateOrdersData } from "../validators";

export default function CreateOrder({
    open,
    handleClose,
}) {
    const [newOrder, setNewOrder] = useState({});
    const [selOrg, setSelOrg] = useState(null);
    const [errors, setErrors] = useState({});

    const authContext = useContext(AuthContext);

    // Handles individual field updates to the new order's state
    const changeHandler = (e) => {
        const { name, value } = e.target;
        setNewOrder({
            ...newOrder,
            [name]: value
        });
    }

    // Handles batch updates to the new order's state
    const batchChangeHandler = (updates) => {
        setNewOrder({
            ...newOrder,
            ...updates
        })
    }

    const handleCancel = () => {
        setNewOrder({});
        setSelOrg(null);
        setErrors({});
        handleClose();
    }

    // Handles the submission of the create order form
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setErrors({});
            const [isValid, validationErrors] = validateOrdersData(newOrder);
            if (!isValid) {
                setErrors(validationErrors);
                console.log("Validation errors found: ", validationErrors);
                return;
            }
            const payload = {
                data: {
                    attributes: newOrder,
                    logs: {
                        user: await authContext.getCurrentUser(),
                        comment: "",
                    }
                }
            }
            await ordersService.createOrder(payload);
            setErrors({});
            setNewOrder({});
            setSelOrg(null);
            handleClose();

        } catch (error) {
            console.error("Error creating order: ", error);
        }
    }

    return (
        <Dialog open={open} onClose={handleCancel}>

            {/* Dialog Title and Context */}
            <DialogTitle> Create Order</DialogTitle>
            <DialogContent>

                <DialogContentText>
                    To create a new order, please input the requested information here.
                </DialogContentText>

                {/* Form for Creating the Order */}
                <form onSubmit={handleSubmit} id="subscription-form">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                name="desc"
                                type="text"
                                multiline
                                rows={3}
                                label="Order Description"
                                fullWidth
                                onChange={changeHandler}
                                error={errors.desc}
                                helperText={errors.desc}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                name="qty"
                                type="number"
                                label="Quantity"
                                fullWidth
                                onChange={changeHandler}
                                error={errors.qty}
                                helperText={errors.qty}
                            />

                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectOrganization
                                changeHandler={batchChangeHandler}
                                selectedOrganization={selOrg}
                                error={errors.organization}
                            />

                           
                        </Grid>
                    </Grid>


                </form>

            </DialogContent>

            {/* Dialog action buttons */}
            <DialogActions>
                <MDButton
                    color="dark"
                    variant="gradient"
                    size="small"
                    onClick={handleCancel}>
                    Cancel
                </MDButton>
                <MDButton
                    color="dark"
                    variant="gradient"
                    size="small"
                    type="submit"
                    form="subscription-form">
                    Create
                </MDButton>
            </DialogActions>

        </Dialog >
    );
}
